import orange from '@material-ui/core/colors/orange'

const green = {
  400: '#6fcf97',
  500: '#27AE60',
  600: '#219653',
  700: '#1C492F',
}

const grey = {
  100: '#333333',
  200: '#4F4F4F',
  300: '#828282',
  400: '#BDBDBD',
  500: '#E0E0E0',
  600: '#F2F2F2',
  // 700: '#1C492F',
}

const red = {
  500: '#EB5757',
}

export default {
  spacing: 4,
  palette: {
    grey,
    green,
    primary: {
      ...green,
      light: '#6fcf97',
      main: '#27AE60',
      dark: '#219653',
      contrastText: '#fff',
    },
    secondary: {
      light: orange[300],
      main: orange['A700'],
      dark: orange[700],
      contrastText: '#fff',
    },
    error: {
      light: red[500],
      main: red[500],
    },
    text: {
      primary: '#4F4F4F',
      secondary: '#333333',
    },
  },
  status: {
    danger: 'orange',
  },
  typography: {
    h1: {
      fontSize: 40,
    },
    h2: {
      fontSize: 32,
    },
    h3: {
      fontSize: 20,
    },
    caption: {
      fontSize: 14,
    },
    button: {
      fontWeight: 400,
      textAlign: 'capitalize',
    },
  },
  overrides: {
    MuiIconButton: {
      root: {
        '&:hover': { backgroundColor: 'transparent' },
        padding: 0,
      },
    },
  },
}
